module.exports = __webpack_public_path__ + "static/img/LOGO.ba4e886.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ocean/img/LOGO.png
// module id = DH55
// module chunks = 1